<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script lang="javascript">
import { mapState, mapMutations } from 'vuex'
export default { 
  created() {
      console.log('------------------初始化阶段 App s------------------')
      this.initStore()
      console.log('------------------初始化阶段 App e------------------')
  },
  computed: {
        ...mapState(['userInfo'])
    },
  methods: {
        ...mapMutations(['initStore']),
        checkLogin(cb) {
            if (!this.isLogined()) {
                return
            }
            cb()
        },
        isLogined() {
            return this.userInfo.token.length > 0
        },
  }
}

</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}


</style>
